export const FIELD_HEIGHT = 45;
export const FIELD_WIDTH = '12rem';